
export default {
  name: 'slider-component',
  components: {},
  props: {"sliderData": null},
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    updateSliders: function(IndicatorsStock, IndicatorsBenchmark) {
      var key;
      var keys = Object.keys(IndicatorsStock);
    
        // set span text
        for(var z = 0; z < keys.length; z++) {
          key = keys[z];          
          document.getElementById("tooltip" + z.toString()).innerHTML = "Stock: " + (IndicatorsStock[key]["value"] *100).toFixed(2) + "% --- Benchmark: " + (IndicatorsBenchmark[key]["value"] *100).toFixed(2) + "%" ;
          document.getElementById("slider-stock-" + z.toString()).value = (IndicatorsStock[key]["bin"]).toFixed(2) ;
    
          document.getElementById("slider-benchmark-" + z.toString()).value = (IndicatorsBenchmark[key]["bin"]).toFixed(2) ;
        }
    
    
    }

  }
}


